module.exports = __webpack_public_path__ + "static/media/banner.2b1f2d4f.png";